import React from 'react';

import { Typography } from 'antd';

import PermissionTypeIcon from './PermissionTypeIcon';

import { deleteObjectField } from 'utils';
import classnames from 'classnames';

import { useCheckDisabledAddDeletePermission } from './hooks';

import { SUB_ADMIN_GROUP_PERMISSION } from './constants';

import './RolePermissionGroup.less';
import PermissionGroupButton from './PermissionGroupButton';

const { Text } = Typography;

const RolePermissionGroup = (props) => {
  const { title, permissionListGrouped, type, formRole } = props;

  const { filterNonSubAdminPermissions, isSuperAdmin } =
    useCheckDisabledAddDeletePermission();

  const handleClickAddAll = () => {
    let nextPermissionListGrouped = [...permissionListGrouped];

    const filteredPermission = filterNonSubAdminPermissions(
      nextPermissionListGrouped
    );

    filteredPermission.map((permitData) => {
      deleteObjectField(permitData, ['isNew']);
      return permitData;
    });

    let nextPermissions = [
      ...formRole?.values?.permissions,
      ...filteredPermission,
    ];

    formRole.setFieldValue('permissions', nextPermissions);
  };

  const handleClickRemoveAll = () => {
    let nextPermissions = [...formRole?.values?.permissions];

    permissionListGrouped.forEach((permitData) => {
      const findPermitIndex = nextPermissions.findIndex(
        (permit) => permit?.permissionName === permitData?.permissionName
      );
      if (
        !SUB_ADMIN_GROUP_PERMISSION.includes(permitData?.permissionName) ||
        isSuperAdmin
      ) {
        nextPermissions.splice(findPermitIndex, 1);
      }
    });

    formRole.setFieldValue('permissions', nextPermissions);
  };

  return (
    <div
      className={classnames('role-permission-group__wrap', {
        'role-permission-group__wrap--add': type === 'add',
        'role-permission-group__wrap--remove': type === 'remove',
      })}
    >
      <div className='role-permission-group__title'>
        <Text ellipsis>{title}</Text>
        {type === 'add' ? (
          <PermissionGroupButton type={'add'} onClick={handleClickAddAll} />
        ) : type === 'remove' ? (
          <PermissionGroupButton
            type={'remove'}
            onClick={handleClickRemoveAll}
          />
        ) : null}
      </div>
      <div className='role-permission-group__list'>
        {permissionListGrouped?.length > 0 &&
          permissionListGrouped.map((permitData) => {
            return (
              <div
                key={`permisison__${permitData?.permissionDisplayName}`}
                className={classnames('role-permission-group__list-item', {
                  'role-permission-group__list-item--new': permitData?.isNew,
                })}
              >
                <PermissionTypeIcon
                  type={type}
                  permitData={permitData}
                  formRole={formRole}
                />
                <Text>{permitData?.permissionDisplayName}</Text>
              </div>
            );
          })}
      </div>
    </div>
  );
};

export default RolePermissionGroup;
